import { FC, useState } from "react";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import CustomButton from "ui/Button";
import { DATE_FORMAT, ICON_NAMES } from "utils/constant";
import { useTranslation } from "react-i18next";
import { SettlementFilter } from "api/accounting";
import DatePickerComponent from "ui/Date";
import CustomDropDownList from "ui/dropDown";
import { Vessel } from "interface/vessel";
import { VesselRenderItem } from "ui/dropdownItemList/VesselRenderItem";
import { getVesselFilter } from "api/vessel";

interface CustomProps {
	pageSize: number;
	setFilterOptions: (options: SettlementFilter) => void;
	filterOptions: SettlementFilter;
	exportAsPDF: () => void;
	exportAsExcel: () => void;
}
const Filter: FC<CustomProps> = ({
	setFilterOptions,
	filterOptions,
	exportAsPDF,
	...props
}) => {
	const { t } = useTranslation();

	const [tempFilter, setTempFilter] = useState<Partial<SettlementFilter>>({});

	const applySettlementNumber = () => {
		const newValue = tempFilter.settlementNumber || "";
		const currentValue = filterOptions.settlementNumber || "";
		if (newValue === currentValue) return;
		setFilterOptions({
			...filterOptions,
			settlementNumber: tempFilter.settlementNumber,
			take: props.pageSize,
			skip: 0,
		});
	};

	const applyFromDate = () => {
		const newValue = tempFilter.fromDate;
		if (newValue === undefined || newValue === filterOptions.fromDate) return;
		setFilterOptions({
			...filterOptions,
			fromDate: newValue,
			take: props.pageSize,
			skip: 0,
		});
	};

	const applyToDate = () => {
		const newValue = tempFilter.toDate;
		if (newValue === undefined || newValue === filterOptions.toDate) return;
		setFilterOptions({
			...filterOptions,
			toDate: newValue,
			take: props.pageSize,
			skip: 0,
		});
	};

	const settlementNumberValue =
		tempFilter.settlementNumber == null || tempFilter.settlementNumber === ""
			? null
			: Number(tempFilter.settlementNumber);

	const handleVessel = (vessel: Vessel) => {
		setFilterOptions({
			...filterOptions,
			vesselHullId: vessel.id as any,
			vesselId: vessel.id,
			vesselName: vessel.id ? vessel.nm : "",
			vesselLedgerAccountNumber: vessel.res?.toString(),
			take: props.pageSize,
			skip: 0,
		});
	};


	return (
		<div className="filter-container">
			<div className="filter-items settlement-filter-items">
				<div className="settlement-filter-field" style={{ width: "170px" }}>
					<DatePickerComponent
						placeholder=" "
						label={t("FromDate")}
						format={DATE_FORMAT}
						className="height-inherit"
						style={{ width: "100%" }}
						value={tempFilter.fromDate !== undefined ? tempFilter.fromDate : filterOptions.fromDate}
						onChange={(e) =>
							setTempFilter({ ...tempFilter, fromDate: e.target.value })
						}
						onBlur={() => applyFromDate()}
					/>
				</div>
				<div className="settlement-filter-field" style={{ width: "170px" }}>
					<DatePickerComponent
						placeholder=" "
						label={t("ToDate")}
						className="height-inherit"
						format={DATE_FORMAT}
						style={{ width: "100%" }}
						value={tempFilter.toDate !== undefined ? tempFilter.toDate : filterOptions.toDate}
						onChange={(e) =>
							setTempFilter({ ...tempFilter, toDate: e.target.value })
						}
						onBlur={() => applyToDate()}
					/>
				</div>

				<div className="settlement-filter-field" style={{ width: "170px" }}>
					<CustomDropDownList
						data={[]}
						filterable={true}
						dataItemKey="id"
						textField="nm"
						label={t("Vessel")}
						value={{
							id: filterOptions.vesselId || null,
							nm: filterOptions.vesselName || " ",
						}}
						// label="Velg Fart�y"
						defaultItem={{ id: null, nm: t("All") }}
						onSelect={handleVessel}
						serverFilter={true}
						itemRender={VesselRenderItem()}
						serverFilterApi={getVesselFilter}
					/>
				</div>
				<div className="settlement-filter-field" style={{ width: "170px" }}>
					<NumericTextBox
						className="height-inherit"
						label={t("SettlementNumber")}
						placeholder=" "
						style={{ width: "100%" }}
						value={Number.isNaN(settlementNumberValue) ? null : settlementNumberValue}
						onChange={(e) =>
							setTempFilter({
								...tempFilter,
								settlementNumber:
									e.value == null ? undefined : String(e.value),
							})
						}
						onKeyDown={(e: any) => {
							if (e.key === "Enter") applySettlementNumber();
						}}
						onBlur={() => applySettlementNumber()}
						spinners={false}
						format=""
					/>
				</div>
			</div>

			<div className="filter-end-btn settlement-filter-end-btn">
				{/*<CustomButton*/}
				{/*	label={"PDF"}*/}
				{/*	onClick={() => exportAsPDF()}*/}
				{/*	iconName={ICON_NAMES.Download}*/}
				{/*/>*/}
				<CustomButton
					label={"Excel"}
					onClick={() => props.exportAsExcel()}
					iconName={ICON_NAMES.Download}
				/>
			</div>
		</div>
	);
};

export default Filter;
